import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Router from "./router/index";
import { Provider } from "react-redux";
import store from "./redux/index";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
